import { useSelector } from "react-redux";
import { Button, Typography } from "@mui/material";

const GradientButton = ({
  height = 50,
  width = "80%",
  sx = {},
  style = {},
  onClick,
  text = "Radiant Button",
  ...props
}) => {
  const theme = useSelector((state) => state.themeValue.colors);
  const start = theme?.primary_gradient_start_color || "#FF2D95";
  const end = theme?.primary_gradient_end_color || "#7B1FA2";

  return (
    <Button
      onClick={onClick}
      variant="contained"
      color="primary"
      disableElevation
      sx={{
        borderRadius: "5px",
        width,
        height,
        background: `linear-gradient(90deg, ${start}, ${end})`,
        color: "#FFFFFF !important",
        fontWeight: "bold",
        fontSize: 16,
        textTransform: "none",
        boxShadow: "none",
        "&:hover": {
          background: `linear-gradient(90deg, ${end}, ${start})`,
          color: "#FFFFFF !important",
          boxShadow: "none",
        },
        "& .MuiTypography-root": {
          color: "#FFFFFF !important",
          fontWeight: "bold",
        },
        ...sx,
        ...style,
        borderRadius: "5px",
      }}
      {...props}
    >
      <Typography component="span" sx={{ color: "#FFFFFF !important", fontWeight: "bold" }}>
        {text}
      </Typography>
    </Button>
  );
};

export default GradientButton;
